import React, {PropTypes} from 'react';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const VirtualEvent = ({
  virtualEvents,
  showAllEvent,
  onAddClick,
  onQuantityChange,
}) => (
  <div>
    { showAllEvent
      ? <div className="panel panel-primary">
        {virtualEvents.map((virtualEvent, index) =>
          <div key={index}>
            <div className="panel-heading">
              <h2 className="panel-title">{virtualEvent.name}</h2>
            </div>
            <div className="panel-body">
              <div className="list-group">
                <div className="list-group-item-labeled">
                  <div className="list-group-item-labeled-child"
                    style={{width: 80}}>
                    <span>{'Time'}</span>
                    <span>{'N/A'}</span>
                  </div>
                  <div className="list-group-item-labeled-child"
                    style={{width: 80}}>
                    <span>{'Price ($)'}</span>
                    <span>{virtualEvent.price.formatCurrency(2)}</span>
                  </div>
                  <div className="list-group-item-labeled-child"
                    style={{width: 80}}>
                    <span>{'Available'}</span>
                    <span>{'N/A'}</span>
                  </div>
                  <div className="list-group-item-labeled-child"
                    style={{width: 80}}>
                    <span>{'Quantity'}</span>
                    <input
                      style={{width: 80}}
                      value={virtualEvent.quantity}
                      type="number"
                      min="0"
                      step="1"
                      onChange={event => onQuantityChange(virtualEvent.id, event.target.value)} />
                  </div>
                  <div className="list-group-item-labeled-child"
                    style={{width: 100}}>
                    <button
                        className={virtualEvent.quantity > 0 ? 'btn btn-warning' : 'btn btn-link'}
                        type="button"
                        disabled={!virtualEvent.quantity}
                        onClick={() => onAddClick({
                          id: virtualEvent.id,
                          name: virtualEvent.name,
                          quantity: virtualEvent.quantity,
                          price: virtualEvent.price,
                          owner: virtualEvent.owner
                        })}
                    ><i className="fa fa-shopping-cart" /> { virtualEvent.quantity > 0 ? `Add (${virtualEvent.quantity})` : 'Add'}</button>
                  </div>
                  <div className="list-group-item-labeled-child"
                    style={{width: 80}}>
                    <span>{'In Cart'}</span>
                    <span>{virtualEvent.countInCart}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
      : null
    }
  </div>
);

VirtualEvent.defaultProps = {
  showAllEvent: false,
  id: null,
  name: '',
  quantity: 0,
  price: 0,
  countInCart: 0
};

VirtualEvent.propTypes = {
  virtualEvents: PropTypes.arrayOf(PropTypes.object),
  showAllEvent: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  quantity: PropTypes.number,
  price: PropTypes.number,
  countInCart: PropTypes.number,
  onAddClick: PropTypes.func,
  onQuantityChange: PropTypes.func,
};

export default VirtualEvent;



// WEBPACK FOOTER //
// ./src/features/shared/VirtualEvent.jsx